var PLANETARY_HEALTH_WORKSPACE_ID, Question, W, alt, exportInterventions, exportIsof, exportJustificationPromise, exportPicoData, exportPopulation, exportQuestionAndRecommendation, exportYesNoTextField, get, getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel, getConclusionsContentPromise, getContentWithReferencesPromise, getEtdPrintout, getQuestionSectionsContentPromise, getRecommendationDirectionAndStrength, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationTextContent, getRemarksContent, getSofPrintout, mediator, picoDataMapper, prepareCodes, processReferencesForExport, renderEditorValue, renderEditorValueFromRecommendationMetadata, sanitizeReference, _ref, _ref1;

get = require('lodash').get;

_ref = require('lib/services/covid_exporter/utils'), exportIsof = _ref.exportIsof, exportJustificationPromise = _ref.exportJustificationPromise, exportYesNoTextField = _ref.exportYesNoTextField, getAssessmentSectionsPromises = _ref.getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel = _ref.getCertaintyOfEvidenceAndLabel, getConclusionsContentPromise = _ref.getConclusionsContentPromise, getEtdPrintout = _ref.getEtdPrintout, getQuestionSectionsContentPromise = _ref.getQuestionSectionsContentPromise, getRecommendationDirectionAndStrength = _ref.getRecommendationDirectionAndStrength, getRecommendationMetadata = _ref.getRecommendationMetadata, getRecommendationMetadataOrUndefined = _ref.getRecommendationMetadataOrUndefined, getRecommendationTextContent = _ref.getRecommendationTextContent, getRemarksContent = _ref.getRemarksContent, getSofPrintout = _ref.getSofPrintout, renderEditorValue = _ref.renderEditorValue, renderEditorValueFromRecommendationMetadata = _ref.renderEditorValueFromRecommendationMetadata, prepareCodes = _ref.prepareCodes;

PLANETARY_HEALTH_WORKSPACE_ID = require('lib/planetary_health_extraction_helper').PLANETARY_HEALTH_WORKSPACE_ID;

getContentWithReferencesPromise = require('lib/services/document_sections_exporter/utils').getContentWithReferencesPromise;

mediator = require('mediator');

alt = require('alt');

_ref1 = require('lib/references_utils'), processReferencesForExport = _ref1.processReferencesForExport, sanitizeReference = _ref1.sanitizeReference;

Question = require('models/question');

W = require('when/when');

exportInterventions = function(question, type) {
  var interventions, _ref2, _ref3, _ref4, _ref5;
  if (type == null) {
    type = 'WHOIntervention';
  }
  switch (question.type) {
    case 'diagnostic':
      interventions = [
        {
          '@id': '_:int1',
          '@type': type,
          'name': question['indexTest'],
          'codes': prepareCodes((_ref2 = get(question, 'codes.indexTest')) != null ? _ref2 : {})
        }
      ];
      if (question['comparatorTestPresent']) {
        interventions.push({
          '@id': '_:int2',
          '@type': type,
          'name': question['comparatorTest'],
          'codes': prepareCodes((_ref3 = get(question, 'codes.comparatorTest')) != null ? _ref3 : {})
        });
      }
      return interventions;
    default:
      return [
        {
          '@id': '_:int1',
          '@type': type,
          'name': question['intervention'],
          'codes': prepareCodes((_ref4 = get(question, 'codes.intervention')) != null ? _ref4 : {}, {
            '@id': '_:int2',
            '@type': type,
            'name': question['comparison'],
            'codes': prepareCodes((_ref5 = get(question, 'codes.comparison')) != null ? _ref5 : {})
          })
        }
      ];
  }
};

exportPopulation = function(question, recommendation) {
  var setting, _ref2;
  setting = renderEditorValue(get(recommendation, 'templateData.question.sections.setting.content'));
  if (!setting) {
    setting = question['settings'];
  }
  if (!setting) {
    setting = void 0;
  }
  return [
    {
      '@id': '_:pop1',
      '@type': 'WHOPopulation',
      'ages': _.reject(getRecommendationMetadata(recommendation, 'age'), function(v) {
        return v === 'any';
      }),
      'codes': prepareCodes((_ref2 = get(question, 'codes.population')) != null ? _ref2 : {}),
      'description': question['healthProblemOrPopulation'],
      'setting': setting
    }
  ];
};

picoDataMapper = function(key, type) {
  return function(pico, idx) {
    if (!pico.selected) {
      return null;
    }
    return {
      '@id': "" + key + idx,
      '@type': type,
      name: pico.value,
      codes: prepareCodes(pico.codes)
    };
  };
};

exportPicoData = function(typePrefix, question) {
  var comparator, intervention, outcome, population, _ref2;
  _ref2 = question.picoData || {}, comparator = _ref2.comparator, population = _ref2.population, intervention = _ref2.intervention, outcome = _ref2.outcome;
  return {
    comparator: (comparator || []).map(picoDataMapper('_:comp', "" + typePrefix + "Comparator")),
    intervention: (intervention || []).map(picoDataMapper('_:int', "" + typePrefix + "Intervention")),
    population: (population || []).map(picoDataMapper('_:pop', "" + typePrefix + "Population")),
    outcome: (outcome || []).map(picoDataMapper('_:out', "" + typePrefix + "Outcome"))
  };
};

exportQuestionAndRecommendation = function(question, recommendations, projectId) {
  var assessmentPromises, conclusionsPromise, isDiagnostic, isGps, justificationPromise, picoData, projectName, questionModel, questionSectionsPromise, recommendation, recommendationContent, recommendationId, recommendationTextPromise, relatedEvidenceIds, relatedEvidenceProfiles, remarksContent, remarksPromise, typePrefix;
  projectName = mediator.projects.get(projectId).get('name');
  questionModel = new Question(question);
  isDiagnostic = question['type'] === 'diagnostic';
  isGps = question['type'] === 'good-practice-statement';
  recommendationId = _.first(question['recommendationIds']);
  recommendation = get(recommendations, recommendationId);
  if (!recommendation) {
    return W.resolve();
  }
  remarksContent = getRemarksContent(recommendation);
  remarksPromise = getContentWithReferencesPromise("remarks_" + recommendationId, remarksContent);
  recommendationContent = getRecommendationTextContent(recommendation, isGps);
  recommendationTextPromise = getContentWithReferencesPromise("recommendation_" + recommendationId, recommendationContent);
  relatedEvidenceIds = get(recommendation, 'templateData.relatedEvidenceIds');
  relatedEvidenceProfiles = (relatedEvidenceIds != null ? relatedEvidenceIds.length : void 0) ? relatedEvidenceIds.map(function(id) {
    var evidence, profile, _ref2;
    evidence = alt.stores.PublicationPlatformStore.getState().getIn(['common', 'questions', id], Immutable.Map()).toJS();
    profile = new Question(evidence);
    if (!((_ref2 = profile.get('outcomes')) != null ? _ref2.length : void 0)) {
      return null;
    }
    return {
      name: profile.get('question'),
      isofData: exportIsof(profile, projectName)
    };
  }) : [];
  typePrefix = mediator.services.switches.isServerSwitchOn('chronicPainFeatures') ? 'ChronicPain' : 'WHO';
  picoData = exportPicoData(typePrefix, question);
  assessmentPromises = getAssessmentSectionsPromises(recommendation);
  justificationPromise = exportJustificationPromise(recommendation);
  conclusionsPromise = getConclusionsContentPromise(recommendation, ['recommendation', 'goodPracticeStatement']);
  questionSectionsPromise = getQuestionSectionsContentPromise(recommendation);
  return W.all([recommendationTextPromise, remarksPromise, assessmentPromises, justificationPromise, conclusionsPromise, questionSectionsPromise]).then(function(_arg) {
    var allReferenceIds, assessment, certaintyOfEvidence, coexistingConditions, comparison, conclusions, etdPrintoutPromise, fullReferencesData, gradeCertaintyOfEvidenceLabel, interventionDescription, isofData, justification, plainLanguageSummary, questionSections, recommendationContent, recommendationDirection, recommendationIntentKey, recommendationStrength, recommendationText, recommendationValue, referenceIds, references, referencesFromTablesIds, remarks, remarksText, sofPrintoutPromise, _ref2, _ref3;
    recommendationContent = _arg[0], remarks = _arg[1], assessment = _arg[2], justification = _arg[3], conclusions = _arg[4], questionSections = _arg[5];
    _ref2 = getRecommendationDirectionAndStrength(recommendation), recommendationDirection = _ref2[0], recommendationStrength = _ref2[1], recommendationValue = _ref2[2];
    if (justification != null) {
      conclusions['sections']['justification'] = justification;
    }
    interventionDescription = _.compact([question['intervention'], question['comparison']]).join(', ');
    coexistingConditions = _.chain(getRecommendationMetadata(recommendation, 'coexistingCondition', '')[0].split(';')).map(function(value) {
      return _.str.capitalize(value.trim());
    }).compact().value();
    _ref3 = getCertaintyOfEvidenceAndLabel(recommendation), certaintyOfEvidence = _ref3[0], gradeCertaintyOfEvidenceLabel = _ref3[1];
    comparison = question.type === 'diagnostic' && !question.comparatorTestPresent ? void 0 : [
      {
        '@id': '_:int2'
      }
    ];
    isofData = exportIsof(questionModel, projectName);
    plainLanguageSummary = _.reject(getRecommendationMetadata(recommendation, 'plainLanguageSummary'), function(plr) {
      return _.isEmpty(plr.link);
    });
    etdPrintoutPromise = getEtdPrintout(projectId, questionModel, recommendationId);
    sofPrintoutPromise = getSofPrintout(questionModel);
    recommendationText = recommendationContent.htmlContent;
    remarksText = remarks.htmlContent;
    references = _.map(_.extend({}, (assessment != null ? assessment.sections : void 0) || {}, (conclusions != null ? conclusions.sections : void 0) || {}), function(section) {
      return section.referenceData || {
        references: [],
        referencesFromTables: [],
        fullReferencesData: []
      };
    }).concat([_.omit(recommendationContent, 'htmlContent'), _.omit(remarks, 'htmlContent')]);
    referenceIds = _.chain(references).pluck('references').flatten().compact().uniq().value();
    referencesFromTablesIds = _.chain(references).pluck('referencesFromTables').flatten().compact().uniq().value();
    allReferenceIds = _.union(referenceIds, referencesFromTablesIds);
    fullReferencesData = _.chain(references).pluck('fullReferencesData').flatten().compact().map(function(ref) {
      return _.map(_.values(ref), sanitizeReference);
    }).flatten().value();
    references = processReferencesForExport(allReferenceIds, fullReferencesData);
    recommendationIntentKey = mediator.activeWorkspace === PLANETARY_HEALTH_WORKSPACE_ID ? 'recommendationModule' : 'recommendationIntent';
    return W.all([etdPrintoutPromise, sofPrintoutPromise]).then(function(_arg1) {
      var etdPrintout, sofPrintout, _ref4, _ref5, _ref6, _ref7;
      etdPrintout = _arg1[0], sofPrintout = _arg1[1];
      return {
        '@id': question['_id'],
        '@type': 'WHORecommendation',
        'adapted': getRecommendationMetadata(recommendation, 'adapted', false)[0],
        'adolopment': _.union(['all'], getRecommendationMetadata(recommendation, 'adolopment')),
        'age': _.union(['all'], getRecommendationMetadata(recommendation, 'age')),
        'agreeRexDomains': getRecommendationMetadata(recommendation, 'agreeRexDomains'),
        "authors": renderEditorValueFromRecommendationMetadata(getRecommendationMetadata(recommendation, 'authors')),
        'certaintyOfEvidence': _.union(['all'], getRecommendationMetadata(recommendation, 'certaintyOfEvidence')),
        'certaintyOfEvidenceTextInput': renderEditorValueFromRecommendationMetadata(getRecommendationMetadata(recommendation, 'certaintyOfEvidenceTextInput')),
        'coexistingCondition': coexistingConditions,
        'diagnostic': isDiagnostic,
        'equityItem2': exportYesNoTextField(getRecommendationMetadata(recommendation, 'equityItem2')),
        'etdPrintout': etdPrintout,
        'gps': isGps,
        'gradingEvidenceMethod': _.union(['all'], getRecommendationMetadata(recommendation, 'gradingEvidenceMethod')),
        'informal': getRecommendationMetadata(recommendation, 'informal', false)[0],
        'intendedPopulation': getRecommendationMetadata(recommendation, 'intendedPopulation'),
        'intervention': exportInterventions(question),
        'interventionDescription': interventionDescription,
        'isofData': isofData,
        'picoData': picoData,
        'plainLanguageSummary': plainLanguageSummary,
        'planetaryHealth': getRecommendationMetadata(recommendation, 'planetaryHealth'),
        'population': exportPopulation(question, recommendation),
        'populationDescription': question['healthProblemOrPopulation'],
        'publicationDate': getRecommendationMetadataOrUndefined(recommendation, 'publicationDate'),
        'recommendationIntent': _.union(['all'], getRecommendationMetadata(recommendation, recommendationIntentKey)),
        'references': (references || Immutable.List()).toJS(),
        'relatedEvidenceProfiles': relatedEvidenceProfiles,
        'reportedAsGPS': getRecommendationMetadata(recommendation, 'reportedAsGPS', false)[0],
        'research': getRecommendationMetadata(recommendation, 'research', false)[0],
        'sofPrintout': sofPrintout,
        'strengthOfRecommendation': _.union(['all'], getRecommendationMetadata(recommendation, 'age')),
        'strengthOfRecommendationText': renderEditorValueFromRecommendationMetadata(getRecommendationMetadata(recommendation, 'strengthOfRecommendationText')),
        'transformed': getRecommendationMetadata(recommendation, 'transformed', false)[0],
        'question': [
          {
            '@id': '_:q1',
            '@type': 'WHOQuestion',
            'intervention': [
              {
                '@id': '_:int1'
              }
            ],
            'comparison': comparison,
            'population': [
              {
                '@id': '_:pop1'
              }
            ],
            'gradeCertaintyOfEvidence': certaintyOfEvidence,
            'gradeCertaintyOfEvidenceLabel': gradeCertaintyOfEvidenceLabel,
            'perspective': (questionSections != null ? (_ref4 = questionSections.sections) != null ? (_ref5 = _ref4.perspective) != null ? _ref5.content : void 0 : void 0 : void 0) || ''
          }
        ],
        'recommendation': {
          'coi': (questionSections != null ? (_ref6 = questionSections.sections) != null ? (_ref7 = _ref6.coi) != null ? _ref7.content : void 0 : void 0 : void 0) || '',
          'direction': recommendationDirection,
          'strength': recommendationStrength,
          'recommendationValue': recommendationValue,
          'assessmentSummary': assessment,
          'conclusions': conclusions,
          'value': recommendationText,
          'remarks': remarksText
        }
      };
    });
  });
};

module.exports = exportQuestionAndRecommendation;
